import { Box } from '@mui/material';
import { useIntl } from 'react-intl';

import { useMetricProjectsDropdown } from './useMetricProjectsDropdown';
import Dropdown from '../../../wrapper-components/Dropdown/Dropdown';

export const MetricProjectsDropdown = () => {
  const { formatMessage } = useIntl();

  const { projectOptions, handleProjectChange, isProjectsLoading, selectedProjectId } =
    useMetricProjectsDropdown();

  return (
    <Box>
      <Dropdown
        id="metrics-project-dropdown"
        options={projectOptions}
        onChange={handleProjectChange}
        label={formatMessage({ id: 'workspaceCommon.content.dropdown.project.label' })}
        placeholder={formatMessage({ id: 'workspaceCommon.content.dropdown.project.placeholder' })}
        disabled={isProjectsLoading || projectOptions.length === 0}
        width="medium"
        value={selectedProjectId ?? ''}
      />
    </Box>
  );
};
